export default "__VITE_ASSET__ZtBB3HoD__"